/**
 * Build a `tel:` href from a display phone number, stripping formatting
 * characters but preserving a leading "+" for international numbers.
 */
export function telLink(phone) {
  if (!phone) return null;
  const digits = phone.replace(/[^\d+]/g, '');
  return digits ? `tel:${digits}` : null;
}
